/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAndroid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m17.354 9.734 1.827-3.164a.38.38 0 0 0-.658-.38l-1.85 3.204a11.276 11.276 0 0 0-4.698-1.005c-1.695 0-3.283.36-4.698 1.005L5.427 6.19a.38.38 0 0 0-.658.38l1.827 3.164C3.459 11.44 1.314 14.615 1 18.367h21.95c-.314-3.752-2.46-6.927-5.596-8.633M6.924 15.24a.915.915 0 0 1 0-1.829.915.915 0 0 1 0 1.829m10.103 0a.915.915 0 0 1 0-1.829.915.915 0 0 1 0 1.829"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAndroid as Android };
